// extracted by mini-css-extract-plugin
export var completionBody = "_ce-2";
export var completionCard = "_ce-0";
export var completionFooter = "_ce-3";
export var completionTitle = "_ce-1";